define("settings/components/downgrade-slide-linkinbio-pages", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="tDG--slide" data-test-id="users-slide">
    <div class="o--modalHeader tDG--slideHeader">
      <p class="o--modalHeader__title">
        {{t "account.downgrade.linkinbio_pages.title"}}
      </p>
      <p class="u--m__tb__xs">
        {{t "account.downgrade.linkinbio_pages.subtitle" count=@totalLinkinbioPages}}
      </p>
    </div>
    <div class="o--modalBody tDG--scroll__body">
      <div class="u--row">
        <Downgrade::LinkinbioPages @deleteLinkinbioPage={{@deleteLinkinbioPage}} @linkinbioPages={{@linkinbioPages}} />
      </div>
    </div>
  </div>
  */
  {
    "id": "5ILDk3ad",
    "block": "[[[10,0],[14,0,\"tDG--slide\"],[14,\"data-test-id\",\"users-slide\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"o--modalHeader tDG--slideHeader\"],[12],[1,\"\\n    \"],[10,2],[14,0,\"o--modalHeader__title\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"account.downgrade.linkinbio_pages.title\"],null]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,2],[14,0,\"u--m__tb__xs\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"account.downgrade.linkinbio_pages.subtitle\"],[[\"count\"],[[30,1]]]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"o--modalBody tDG--scroll__body\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"u--row\"],[12],[1,\"\\n      \"],[8,[39,1],null,[[\"@deleteLinkinbioPage\",\"@linkinbioPages\"],[[30,2],[30,3]]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@totalLinkinbioPages\",\"@deleteLinkinbioPage\",\"@linkinbioPages\"],false,[\"t\",\"downgrade/linkinbio-pages\"]]",
    "moduleName": "settings/components/downgrade-slide-linkinbio-pages.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});